import { DynamicConfig } from '@statsig/js-client';

import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

import { ProductType } from '@app/admin/group-level-settings/group-level-settings.interface';

export const GLS_CONFIG_NAME = 'gls_config';

type IGLSDyanmicConfig = {
  profile: {
    group_level_settings: {
      [key in ProductType]: boolean;
    };
    entity_level_settings: {
      vehicle: boolean;
      driver: boolean;
    };
    company_level_settings: {
      [key in ProductType]: boolean;
    };
    profile_management: boolean;
  };
};

@Injectable({ providedIn: 'root' })
export class GroupLevelSettingsConfigService {
  private config: DynamicConfig;

  // method to get the entire config.value object
  public get getConfig(): IGLSDyanmicConfig {
    return this.config.value as IGLSDyanmicConfig;
  }

  constructor(private statsigService: StatsigService) {
    this.config = this.statsigService.evaluateDynamicConfig(GLS_CONFIG_NAME);
  }

  public isProfileManagementEnabled(): boolean {
    return !!this.getConfig?.profile?.profile_management;
  }

  public isGroupLevelSettingsEnabled(): boolean {
    return !!this.getConfig?.profile?.group_level_settings;
  }

  public isEntityLevelSettingsEnabled(entity: string): boolean {
    return !!this.getConfig?.profile?.entity_level_settings && !!this.getConfig.profile.entity_level_settings[entity];
  }

  public isProductGroupLevelSettingsEnabled(product: ProductType): boolean {
    return this.isGroupLevelSettingsEnabled() && this.getConfig.profile.group_level_settings[product];
  }
}